export default __webpack_public_path__ + "static/media/youtube-icon.0b7f016e.svg";